<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div
      :class="{
        'm-auto': true,
      }"
    >
      <HekateAnnouncement />
      <h3
        v-if="formHeading"
        :class="{
          'text-center text-2xl font-bold text-www-color-accent-blue-dark': true,
        }"
      >
        {{ formHeading }}
      </h3>
      <div v-html="formElementContainer" />
      <div
        v-if="thankYouMessage?.buttonPortableText"
        id="formfort-success-message"
        style="display: none"
      >
        <PortableText :portable-data="thankYouMessage.buttonPortableText" />
      </div>
      <SignupSurveyForms v-if="formId === FormIdUtil.names.unifiedSignup" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useFormFiles } from '~/composables/useFormFiles';
import formContainer from './FormContainer';
import { renderToString } from 'vue/server-renderer';
import type { Form } from '~/sanity/types';
import { FormIdUtil } from '@onshape/www-inertia';
import { getProgressiveProfile } from './progressive-profiles/ProgressiveProfileProvider';

const props = defineProps<Form>();
const formId = props.formId || '';

const formContainerVNode = await formContainer(props);
const formElementContainer = await renderToString(formContainerVNode);

const hekateStaticAsset = await useStaticAsset('/global-assets/formfort.js', { tag: 'formfort' });
const translationsStaticAsset = await useStaticAsset('/en/translations/forms.js');
const refreshOldTabsStaticAsset = await useStaticAsset('/global-assets/refresh-old-tabs.js', {
  tag: 'refresh-old-tabs',
});
useFormFiles({
  hekateStaticAsset,
  translationsStaticAsset,
  refreshOldTabsStaticAsset,
}).addFormDefinitionToPage({
  formId,
});
await getProgressiveProfile({ formId }).onSsg();

nextTick(() => {
  const formVariant = props.formVariant || '';
  useFormFiles({
    hekateStaticAsset,
    translationsStaticAsset,
    refreshOldTabsStaticAsset,
  }).loadHekate({ formId });
  useFormInjections({ formId, formVariant });
  useCrossSession().setParamsForFetch({
    params: ['heartbeat', 'currentUserData'],
  });

  getProgressiveProfile({ formId }).onClient();
});
</script>

<style lang="scss">
.uss-hekate .tfc .tfc-form {
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
}
.uss-hekate .tfc .tfc-form .form-title {
  margin-bottom: 15px;
}
.uss-hekate .imgtxt-move-image .imgtxt-wrapper h3 {
  color: #000;
}
.uss-hekate .trial-page.background-wrapper .background-img {
  height: 100%;
  right: 0;
  overflow: visible;
  position: absolute;
  min-height: 100%;
  top: 0%;
  transform: none;
  display: flex;
}
.uss-hekate .trial-page.background-wrapper .background-img:before {
  background-color: #fafafa;
  content: '';
  display: block;
  height: 900px;
  width: 100%;
  position: absolute;
  z-index: -2;
}
#hekate-form-fort-container form .field-container {
  color: inherit !important;
}
@media (max-width: 991px) {
  .uss-hekate .trial-page.background-wrapper .background-img:before {
    height: 1200px;
  }
}
.uss-hekate .trial-page.background-wrapper .background-img img {
  height: auto;
  min-height: auto;
  object-position: bottom left;
  width: 100%;
  vertical-align: bottom;
}
@media (max-width: 1199px) {
  .uss-hekate .trial-page.background-wrapper .background-img img {
    object-fit: contain;
  }
}
@media (max-width: 991px) {
  .uss-hekate .trial-page.background-wrapper .background-img img {
    object-position: bottom;
  }
}
.uss-hekate .hekate-form-fort-container form input {
  margin-bottom: 32px;
}
@media (min-width: 992px) {
  .uss-hekate .tfc .tfc-form {
    padding: 57px 47px;
  }
}
@media (max-width: 991px) {
  .uss-hekate .imgtxt-wrapper {
    display: flex;
    flex-direction: column-reverse;
    gap: 1rem;
  }
  .uss-hekate .tfc .tfc-form {
    padding: 53px 23px;
  }
  .uss-hekate .imgtxt-move-image .imgtxt-image img {
    width: 100%;
  }
  .uss-hekate .trial-page.background-wrapper {
    padding-bottom: 80px !important;
  }
}
@media (max-width: 767px) {
  .uss-hekate .tfc .tfc-form {
    padding: 30px 17px;
  }
  .uss-hekate .imgtxt-move-image .imgtxt-wrapper h3 {
    font-size: 20px;
  }
  .uss-hekate .lb-logo-wrapper {
    max-height: 100%;
  }
  .uss-hekate .lb-logo {
    max-height: 100%;
    max-width: 100%;
  }
}

@media (max-width: 1199px) {
  .body-container-wrapper.uss-hekate {
    margin-bottom: 500px;
  }
}

@media (max-width: 767px) {
  body.hekate-uss .header-container-wrapper {
    justify-content: center;
  }
  body.hekate-uss .header-container-wrapper .osh-mm-mobil-menu-btn,
  body.hekate-uss .header-container-wrapper .osh-mm-collabsable {
    display: none;
  }
  body.hekate-uss .signup-next-button {
    margin: 0px auto 15px !important;
  }
}
body.hekate-uss .os-header-wrapper {
  justify-content: center;
}
body.hekate-uss .os-header-wrapper .osh-mm-nav {
  display: none;
}
body.hekate-uss form .field-checkbox[formid='182'] {
  border: 0;
  margin: 0px auto 30px;
}
body.hekate-uss form .field-checkbox[formid='182'] .field-checkbox-box[data-v-607a82e1] {
  border-right: 0;
}
body.hekate-uss form .field-checkbox[formid='182'] .field-checkbox-label[data-v-607a82e1],
body.hekate-uss
  form
  .field-checkbox[formid='182']
  .field-checkbox-content
  label.field-checkbox-label
  .small-text-label[data-v-607a82e1] {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
body.hekate-uss form .field-checkbox[formid='182'] .field-checkbox-label[data-v-607a82e1] a,
body.hekate-uss
  form
  .field-checkbox[formid='182']
  .field-checkbox-content
  label.field-checkbox-label
  .small-text-label[data-v-607a82e1]
  a {
  color: #1093b0;
}
body.hekate-uss form .field-checkbox[formid='182'] .hekate-error-message {
  border-top: 1px solid red;
  margin-top: 20px;
}
body.hekate-uss .signup-next-button {
  height: 46.8px !important;
  z-index: 2;
}
body.hekate-uss button.back-button {
  background: none;
  border: 0;
  cursor: pointer;
  margin-top: 16px;
}
body.hekate-uss button.back-button:hover {
  text-decoration: underline;
}

.hekate-uss .logo-white-to-gray {
  fill: #3b4550;
}
.hekate-uss footer {
  display: none;
}
.hekate-uss .field-container[formid='182'] {
  max-width: 430px;
  margin: auto;
  text-align: left;
  width: 100%;
}
.hekate-uss .body-container-wrapper {
  background: white;
}
@media (min-width: 1200px) {
  .hekate-uss .tfc .tfc-form {
    padding: 57px 67px;
  }
}
@media (max-width: 991px) {
  .hekate-uss .tfc .tfc-form {
    padding: 53px 43px;
  }
}
@media (max-width: 767px) {
  .hekate-uss .tfc .tfc-form {
    padding: 30px 37px;
  }
}

.signup-next-button-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.os-button.primary-cta {
  border-radius: 5px;
  border: 3px solid #00890b;
  /* cursor: not-allowed; */
  /* opacity: 0.5; */
  min-width: 160px;
  width: fit-content;
  padding: 12px 15px;
  background-color: #00890b;
  color: #fff;
  max-width: 100%;
  text-decoration: none !important;
  transition: 0.3s ease-in-out;
  word-wrap: break-word;
  cursor: pointer;
  display: inline-block;
  font-family: Rajdhani;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1;
  position: relative;
  text-align: center;
  text-transform: uppercase;
}

.back-button {
  color: #bdbdbd;
  font-family: Rajdhani;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  background: none;
  border: 0;
  cursor: pointer;
}

.back-button:hover {
  text-decoration: underline;
}

.uss-lp-header {
  display: none !important;
}

.hekate-uss .uss-lp-header {
  display: block !important;
}

.hekate-uss .standard-header,
.hekate-uss .uss-lp-absolute-header {
  display: none !important;
}

.hekate-input-highlighted .persona-details {
  opacity: 1 !important;
  z-index: 1 !important;
}

.hekate-placeholder .formfort-app .hekate-form-fort-container {
  margin-top: 28px;
}

.hekate-placeholder .hekate-form-fort-container {
  text-align: center;
}

.hekate-input-selected.hekate-input-highlighted .card-body::before {
  background-image: var(--checkImageSrc);
  background-repeat: no-repeat;
  content: '';
  display: block;
  height: 30px;
  position: absolute;
  width: 30px;
  right: 10px;
  top: 10px;
  transition: all 0.3s ease-in-out;
}
@media (max-width: 991px) {
  .hekate-input-selected.hekate-input-highlighted .card-body::before {
    background-size: contain;
    height: 22px;
    right: 50%;
    top: 100%;
    transform: translate(50%, -50%);
    width: 22px;
  }
}
.persona-box:hover {
  background: hsla(0deg, 0%, 76%, 0);
  border-color: #00890b !important;
  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.25) !important;
}

.hekate-input-selected .persona-box {
  border-color: #00890b !important;
  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.25) !important;
}

.hekate-input-selected .persona-box::before {
  background-image: var(--checkImageSrc);
  background-repeat: no-repeat;
  content: '';
  display: block;
  height: 30px;
  position: absolute;
  width: 30px;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.3s ease-in-out;
}
@media (max-width: 767px) {
  .hekate-input-selected .persona-box::before {
    background-size: contain;
    height: 26px;
    right: 0;
    transform: translate(50%, -50%);
    width: 26px;
  }
}
.persona-details .content {
  color: #8a8a8a !important;
  font-size: 17px !important;
  font-weight: 700 !important;
  text-align: center !important;
  min-width: 568px !important;
}

.uss-persona-edu-intent .persona-details {
  top: 45% !important;
}

@media (min-height: 864px) and (max-height: 1199px) {
  .uss-persona-edu-intent .persona-details {
    top: 35% !important;
  }
}
@media (min-height: 1200px) and (max-height: 1440px) {
  .uss-persona-edu-intent .persona-details {
    top: 27% !important;
  }
}
@media (min-height: 1441px) and (max-height: 2000px) {
  .uss-persona-edu-intent .persona-details {
    top: 19% !important;
  }
}
@media (min-height: 2001px) and (max-height: 2500px) {
  .uss-persona-edu-intent .persona-details {
    top: 16% !important;
  }
}

.uss-plan-selection .content {
  font-size: 15px !important;
  color: #3d4647 !important;
  font-weight: 400 !important;
  line-height: 28.1px !important;
  text-align: center !important;
}

.hekate-input-selected.hekate-input-highlighted .plan-line::before {
  background-image: var(--checkImageSrc);
  background-repeat: no-repeat;
  content: '';
  display: block;
  height: 30px;
  left: 50%;
  position: absolute;
  top: 0;
  transform: translate(-50%, -50%);
  width: 30px;
}

.hekate-form-fort-container form {
  flex-direction: column;
}

.progress-bar {
  background-color: #0d6efd;
  color: #fff;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  transition: width 0.6s ease;
  white-space: nowrap;
}

.hekate-loader {
  height: 80px;
}

.hekate-progress-bar {
  height: 33px;
  margin-top: 20px;
}

.hekate-loader,
.hekate-progress-bar {
  align-items: end;
  display: flex;
}

.progress {
  background-color: #d9d9d9;
  border-radius: 0;
  height: 0.5rem;
  margin: 0 auto;
  max-width: 760px;
}

.progress .progress-bar {
  background: #40aa1d;
}

.progress,
.progress-bar {
  display: flex;
  overflow: hidden;
}

.hekate-uss .hekate-progress-bar.d-none {
  display: flex;
}

.d-none {
  display: none !important;
}

.content-wrapper {
  max-width: 665px;
  display: block;
  float: none !important;
  margin-left: auto !important;
  margin-right: auto !important;
  width: 100%;
}

.formfort-loading,
.formfort-loading::after,
.formfort-loading::before {
  animation: formfort-load 1.8s ease-in-out infinite;
  border-radius: 50%;
  height: 2.5em;
  width: 2.5em;
}

.formfort-loading {
  animation-delay: -0.16s;
  color: #81bb5b;
  font-size: 10px;
  margin: 55px auto;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
}

.formfort-loading::before {
  animation-delay: -0.32s;
  left: -3.5em;
}

.formfort-loading::after,
.formfort-loading::before {
  content: '... form loading ...';
  position: absolute;
  top: 0;
}

.formfort-loading::after {
  left: 3.5em;
}

@keyframes formfort-load {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
.show-all,
.show-all-plans-link {
  font-size: 15px;
  line-height: 28px;
}

.show-all-plans-link {
  font-weight: 700;
  color: #00890b;
  text-decoration-line: underline;
}

.show-all {
  color: #3d4647;
  font-weight: 400;
  text-align: center;
  padding-top: 20px;
}
.form-container .hekate-form-fort-container form {
  flex-direction: row;
}
.form-container .hekate-form-fort-container form .signup-next-button {
  height: 48px !important;
}

@media (max-width: 567px) {
  .form-container .hekate-form-fort-container form {
    align-items: center !important;
    flex-direction: column !important;
  }
}
.progress-bar.bg-danger {
  background: #dc3545 !important;
}

#uss-partial-view-container h2 {
  font-size: 32px !important;
  font-weight: 700 !important;
  line-height: 28.1px !important;
  text-align: center !important;
  margin-bottom: 15px !important;
  color: var(--www-color-neutral-medium-dark) !important;
}
#uss-partial-view-container .uss-plan-selection h2 {
  margin-bottom: 0 !important;
}
@media (max-width: 1200px) {
  #uss-partial-view-container h2 {
    font-size: 24px !important;
  }
}
@media (max-width: 767px) {
  #uss-partial-view-container h2 {
    font-size: 20px !important;
  }
}

#base-template .d-flex {
  @apply flex;
}
#base-template .justify-content-center {
  @apply justify-center;
}

#base-template form {
  @apply lg:grid lg:grid-cols-2 lg:gap-3;
}

#base-template form div {
  @apply [&:nth-child(4)]:lg:col-span-2 [&:nth-child(5)]:mt-6 [&:nth-child(5)]:lg:col-span-2;
}
.form-container .hekate-form-fort-container form {
  flex-direction: row;
}
.form-container .hekate-form-fort-container form .signup-next-button {
  height: 49px !important;
}

@media (max-width: 567px) {
  .form-container .hekate-form-fort-container form {
    align-items: center;
    flex-direction: column;
  }
}

.field-checkbox-label a {
  color: var(--www-color-primary-light);
}

#hekate-form-fort-container form .field-container input,
#hekate-form-fort-container form .field-container select,
#hekate-form-fort-container form .field-container textarea {
  color: var(--www-color-neutral-medium-dark) !important;
}

#hekate-form-fort-container .success-message,
#hekate-form-fort-container .thank-you-message {
  font-size: 25.2px !important;
  background-color: var(--www-color-white);
  padding: 30px;
  text-align: center;
  color: var(--www-color-accent-blue-dark);
  box-shadow:
    0 0 32px 0 rgba(0, 0, 0, 0.2),
    0 0 36px 0 hsla(0, 0%, 100%, 0);
  margin-top: 20px;
}

.field-submit button {
  font-weight: 700 !important;
}

.privacy-policy-link {
  color: inherit !important;
}
.privacy-policy-link small {
  color: inherit !important;
}
#highlighted-email-description {
  .field-text-input[field-name='email'] + .readonly-description-field {
    background: var(--www-color-accent-orange-soft);
    p {
      font-weight: 700;
    }
  }
}
</style>
